import { Box } from "@mui/material";

import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useUpdateAuthenticatedUserUserPatchMutation } from "api";
import { SelectInput } from "components/forms";
import { SectionCard } from "components/SectionCard/SectionCard";
import { IUser } from "interfaces/user.interface";

type UserPreferenceProps = {
  preferences?: {
    [key: string]: any;
  } | null;
};

export function UserPreference({ preferences }: UserPreferenceProps) {
  const { t, i18n } = useTranslation();

  const [updateUser] = useUpdateAuthenticatedUserUserPatchMutation();

  const LANG_OPTIONS = [
    {
      id: "nb",
      label: t("Language for Health and Welfare"),
    },
    {
      id: "en",
      label: t("Language English"),
    },
    {
      id: "de",
      label: t("Language Deutch"),
    },
    {
      id: "fr",
      label: t("Language French"),
    },
  ];

  const { handleSubmit, control } = useForm({
    defaultValues: {
      language: preferences?.language ?? i18n.resolvedLanguage,
    },
    mode: "onChange",
  });

  const onSubmit = (data: IUser["preferences"]) => {
    updateUser({ userSelfUpdate: { preferences: data } });
  };

  return (
    <Box component={"form"} onSubmit={handleSubmit(onSubmit)}>
      <SectionCard title={t("Language")}>
        <SelectInput
          label={t("Language")}
          control={control}
          fieldName={"language"}
          options={LANG_OPTIONS}
          onChange={() => handleSubmit(onSubmit)()}
        />
      </SectionCard>
    </Box>
  );
}
